import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScenarioRunSummary } from '../../api/api';
import { runMomentShort } from '../../utils/scenarioRunFormat';
import { statusKind } from './ScenarioRunStatus';

export interface IScenarioTestsButtonProps {
    to: string;
    /** The newest run, or undefined when the environment never had one. */
    latestRun?: ScenarioRunSummary;
}

/**
 * The way from an environment to its scenario tests, with the newest run folded into it.
 *
 * Only a run that needs attention adds anything: a passed run is what everybody expects, so the button then
 * stays plain and the date is in the tooltip. A failed or abandoned run gets a badge, a running one a spinner.
 */
export const ScenarioTestsButton = ({
    to,
    latestRun,
}: IScenarioTestsButtonProps) => {
    const kind = latestRun
        ? statusKind(
              latestRun.stale ? 'abandoned' : latestRun.status ?? 'unknown'
          )
        : undefined;

    const title = latestRun
        ? `Last run ${runMomentShort(latestRun.startedAtUtc)}: ${
              latestRun.stale ? 'abandoned' : latestRun.status
          }, ${latestRun.totals?.failed ?? 0} of ${
              latestRun.totals?.total ?? 0
          } scenario(s) failed`
        : 'No scenario run yet';

    return (
        <Link to={to} className="scenario-tests-btn" title={title}>
            Scenario tests
            {kind === 'failed' && (
                <span className="scenario-tests-btn__badge" aria-hidden>
                    <FontAwesomeIcon icon="exclamation" />
                </span>
            )}
            {kind === 'busy' && (
                <FontAwesomeIcon icon="spinner" spin aria-hidden />
            )}
            <span className="visually-hidden">{title}</span>
        </Link>
    );
};
